import { useEffect, useState } from "react";
import FileAttachmentManager  from "../../../../Components/FileAttachmentManager";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import Tab4 from "./Tab4";
import printerimg from "../../../../assets/print.png";
import {
  useItemGroupMutation,
  useItemCompanyMutation,
  useItemBrandMutation,
  useItemUOMMutation,
  useItemGSTHSNCodeMutation,
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
  useCountryListMutation,
  useCustomsTariffNumberMutation,
  usePostUpdateItemMutation,
  useItemQualityInspectionTemplateMutation,
  useGetItemDetailsDataMutation
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import Attachment from "../../../../utils/Attachment";
import { useGetPaginatedDoctypeDataQuery } from "../../../../store/api/warehousemaster";
import { useUploadFileMutation } from "../../../../store/api/gateEntryApiNew";

const EditForm = () => {

 

  const [tab, settab] = useState(1);
  const navigate = useNavigate();
   const location = useLocation();
        const IdData = location.state?.ItemId;
        const [podata, setpodata] = useState('')
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [ItemGroupApi] = useItemGroupMutation();
  const [ItemCompanyApi] = useItemCompanyMutation();
  const [ItemBrandApi] = useItemBrandMutation();
  const [ItemUOMApi] = useItemUOMMutation();
  const [ItemGSTHSNCodeApi] = useItemGSTHSNCodeMutation();
  const [ItemTaxTemplateApi] = useItemTaxTemplateMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  const [CountryListApi] = useCountryListMutation();
  const [CustomsTariffNumberApi] = useCustomsTariffNumberMutation();
  const [QualityInspectionTemplate] =
    useItemQualityInspectionTemplateMutation();
  const [UpdateItem] = usePostUpdateItemMutation();
  // for Tab1
  const [selected_uom_item_data, setselected_uom_item_data] = useState([]);
  // console.log('uoms:',selected_uom_item_data)
  const [selected_tax_item_data, setselected_tax_item_data] = useState([]);
  // for Tab2
  const [selected_barcodes_item_data, setselected_barcodes_item_data] =
    useState([]);
  const [
    selected_auto_re_order_item_data,
    setselected_auto_re_order_item_data,
  ] = useState([]);
  // for tab3
  const [selected_item_supplier_data, setselected_item_supplier_data] =
    useState([]);
  //  for tab4
  const [selected_customer_details_data, setselected_customer_details_data] =
    useState([]);

  const [ItemCode, setItemCode] = useState("");
  const [group_list, setgroup_list] = useState([]);
  const [select_group, setselect_group] = useState("");
  const [category_list, setcategory_list] = useState([]);
  const [select_category, setselect_category] = useState("");
  const [company_list, setcompany_list] = useState([]);
  const [select_company, setselect_company] = useState("");
  const [brand_list, setbrand_list] = useState([]);
  const [select_brand, setselect_brand] = useState("");
  const [ItemName, setItemName] = useState("");
  const [DefaultUnitOfMeasure_list, setDefaultUnitOfMeasure_list] = useState(
    []
  );
  const [select_DefaultUnitOfMeasure, setselect_DefaultUnitOfMeasure] =
    useState("");
  const [HSN_SAC_list, setHSN_SAC_list] = useState([]);
  const [select_HSN_SAC, setselect_HSN_SAC] = useState("");
  const [StandardSellingRate, setStandardSellingRate] = useState("");

  const [Length_MM, setLength_MM] = useState("");
  const [Width_MM, setWidth_MM] = useState("");
  const [Hieght_MM, setHieght_MM] = useState("");

  const [Disabled, setDisabled] = useState(false);
  const [MaintainStock, setMaintainStock] = useState("");
  const [HasBatchNo, setHasBatchNo] = useState("");
  //click Has Batch checkbox open 3 checkbox and 1 input
    const [autoCreateBatch, setAutoCreateBatch] = useState(false);
    const [hasExpiryDate, setHasExpiryDate] = useState(false);
    const [retainSample, setRetainSample] = useState(false);
    const [sampleQuantity, setsampleQuantity] = useState('');
    const [batchPrefix, setBatchPrefix] = useState(""); 
    // end
    const [HasSerialNo, setHasSerialNo] = useState(0);
    const [SerialNumberSeries, setSerialNumberSeries] = useState("");
    const [SerialNoSetup, setSerialNoSetup] = useState("");
  const [HasVariants, setHasVariants] = useState("");
  const [Description, setDescription] = useState("");
  const [Specification, setSpecification] = useState("");
  const [Image, setImage] = useState("")
  const [fieldErrors, setFieldErrors] = useState({
    ItemCode: false,
    group: false,
    HSN_SAC: false,
    ItemName: false,
    DefaultUnitOfMeasures: false,
  });
  // for api
   const [uploadFile] = useUploadFileMutation();

  useEffect(() => {
   const getItemGroup = async () => {
  try {
    const ItemGroupApiData = await ItemGroupApi();

    // Check if response and nested properties exist
    if (
      ItemGroupApiData &&
      ItemGroupApiData.data &&
      Array.isArray(ItemGroupApiData.data.data)
    ) {
      setgroup_list(ItemGroupApiData.data.data);
    } else {
      console.warn("ItemGroupApi returned no valid data.");
      setgroup_list([]); // optional: clear or set empty list
    }
  } catch (error) {
    console.error("Error fetching item group:", error);
    setgroup_list([]); // fallback
  }
};

   const getItemCategory = async () => {
  try {
    const res = await ItemGroupApi();
    setcategory_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemCategory error:", error);
    setcategory_list([]);
  }
};

const getItemCompany = async () => {
  try {
    const res = await ItemCompanyApi();
    setcompany_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemCompany error:", error);
    setcompany_list([]);
  }
};

const getItemBrand = async () => {
  try {
    const res = await ItemBrandApi();
    setbrand_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemBrand error:", error);
    setbrand_list([]);
  }
};

const getItemDefaultUnitOfMeasure = async () => {
  try {
    const res = await ItemUOMApi();
    setDefaultUnitOfMeasure_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemDefaultUnitOfMeasure error:", error);
    setDefaultUnitOfMeasure_list([]);
  }
};

const getItemHSN_SAC = async () => {
  try {
    const res = await ItemGSTHSNCodeApi();
    setHSN_SAC_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemHSN_SAC error:", error);
    setHSN_SAC_list([]);
  }
};

const getItemDefault_Purchase_Unit_of_Measure = async () => {
  try {
    const res = await ItemUOMApi();
    setDefault_Purchase_Unit_of_Measure_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemDefault_Purchase_Unit_of_Measure error:", error);
    setDefault_Purchase_Unit_of_Measure_list([]);
  }
};

const getItemCountry_of_Origin = async () => {
  try {
    const res = await CountryListApi();
    setCountry_of_Origin_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemCountry_of_Origin error:", error);
    setCountry_of_Origin_list([]);
  }
};

const getItemCustomsTariffNumber = async () => {
  try {
    const res = await CustomsTariffNumberApi();
    setCustomsTariffNumber_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemCustomsTariffNumber error:", error);
    setCustomsTariffNumber_list([]);
  }
};

const getItemQuality_Inspection_Template = async () => {
  try {
    const res = await QualityInspectionTemplate();
    setQuality_Inspection_Template_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemQuality_Inspection_Template error:", error);
    setQuality_Inspection_Template_list([]);
  }
};

const getItemWeightUOM = async () => {
  try {
    const res = await ItemUOMApi();
    setWeightUOM_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemWeightUOM error:", error);
    setWeightUOM_list([]);
  }
};

const getItemDefault_Sales_Unit_of_Measure = async () => {
  try {
    const res = await ItemUOMApi();
    setDefault_Sales_Unit_of_Measure_list(res?.data?.data || []);
  } catch (error) {
    console.error("getItemDefault_Sales_Unit_of_Measure error:", error);
    setDefault_Sales_Unit_of_Measure_list([]);
  }
};

    getItemGroup();
    getItemCategory();
    getItemCompany();
    getItemBrand();
    getItemDefaultUnitOfMeasure();
    getItemHSN_SAC();
    getItemDefault_Purchase_Unit_of_Measure();
    getItemCountry_of_Origin();
    getItemCustomsTariffNumber();
    getItemDefault_Sales_Unit_of_Measure();
    getItemQuality_Inspection_Template();
    getItemWeightUOM();
  }, []);
  const handleFileUpload = async (filename, file, uploadFileMutation) => {
    if (!file || file.length === 0) {
      console.error("No file provided for upload.");
      return null;
    }
  
    const formData = new FormData();
    formData.append("file", file[0],filename); // Ensure file[0] exists
    // formData.append("file_name", filename);
  
    try {
      const res = await uploadFileMutation(formData);
      const fileUrl = res?.data?.message?.file_url;
  
      if (!fileUrl) {
        console.error("File upload response did not contain a file URL.");
        return null;
      }
  
      return fileUrl;
    } catch (error) {
      console.error("File upload failed:", error);
      return null;
    }
  };
    const onInputChangeTabOne = async (value) => {
    if (!value || value.length === 0) {
      console.error("No file selected for upload.");
      return;
    }
  
    const filename = value[0]?.name || null;
  
    if (!filename) {
      console.error("File does not have a valid name.");
      return;
    }
  
    console.log("FILENAME:", filename, "\nVALUE:", value);
  
    try {
      const fileUrl = await handleFileUpload(filename, value, uploadFile);
  
      if (fileUrl) {
        setImage(fileUrl);
        console.log("File uploaded successfully. File URL:", fileUrl);
      } else {
        console.error("File upload failed. No URL returned.");
        setImage(null);
      }
    } catch (err) {
      console.error("Error during file upload:", err);
    }
  };

  const [
    Is_Ineligible_for_Input_Tax_Credit,
    setIs_Ineligible_for_Input_Tax_Credit,
  ] = useState("");
  const [
    Quality_Inspection_Template_list,
    setQuality_Inspection_Template_list,
  ] = useState([]);
  const [
    select_Quality_Inspection_Template,
    setselect_Quality_Inspection_Template,
  ] = useState("");
  const [
    Inspection_Required_before_Purchase,
    setInspection_Required_before_Purchase,
  ] = useState("");
  const [
    Inspection_Required_before_Delivery,
    setInspection_Required_before_Delivery,
  ] = useState("");
  const [Include_Item_In_Manufacturing, setInclude_Item_In_Manufacturing] =
    useState("");
  const [
    Supply_Raw_Materials_for_Purchase,
    setSupply_Raw_Materials_for_Purchase,
  ] = useState("");

  // for Tab2
  const [Shelf_Life_In_Days, setShelf_Life_In_Days] = useState("");
  const [End_of_Life, setEnd_of_Life] = useState("");
  const [DefaultMaterialRequestType, setDefaultMaterialRequestType] =
    useState("");
  const [ValuationMethod, setValuationMethod] = useState("");
  const [WarrantyPeriod, setWarrantyPeriod] = useState("");
  const [WeightPerUnit, setWeightPerUnit] = useState("");
  const [WeightUOM_list, setWeightUOM_list] = useState([]);
  const [select_WeightUOM, setselect_WeightUOM] = useState("");
  const [AllowNegativeStock, setAllowNegativeStock] = useState("");

  // for Tab3
  const [
    Default_Purchase_Unit_of_Measure_list,
    setDefault_Purchase_Unit_of_Measure_list,
  ] = useState([]);
  const [
    select_Default_Purchase_Unit_of_Measure,
    setselect_Default_Purchase_Unit_of_Measure,
  ] = useState("");
  const [Safety_Stock, setSafety_Stock] = useState("");
  const [Minimum_Order_Qty, setMinimum_Order_Qty] = useState("");
  const [Lead_Time_in_days, setLead_Time_in_days] = useState("");
  const [Allow_Purchase, setAllow_Purchase] = useState("");
  const [Is_Customer_Provided_Item, setIs_Customer_Provided_Item] =
    useState("");
  const [Country_of_Origin_list, setCountry_of_Origin_list] = useState([]);
  const [select_Country_of_Origin, setselect_Country_of_Origin] = useState("");
  const [CustomsTariffNumber_list, setCustomsTariffNumber_list] = useState([]);
  const [select_CustomsTariffNumber, setselect_CustomsTariffNumber] =
    useState("");
  const [Delivered_by_Supplier, setDelivered_by_Supplier] = useState("");

    const { data: paginatedData, isLoading: isDataLoading,refetch:warehouserefetch } = useGetPaginatedDoctypeDataQuery({
      doctype: 'Warehouse',
      start: 0,
      page_length: 100000000000,
      filters: [["Warehouse","company","=",select_company]],
      fields: ["name", "disabled"]
    });
  
  
    // console.log("check warehouse is here",paginatedData);
    useEffect(()=>{
      warehouserefetch()
    },[select_company,warehouserefetch])

  // for Tab4
  const [
    Default_Sales_Unit_of_Measure_list,
    setDefault_Sales_Unit_of_Measure_list,
  ] = useState([]);
  const [
    select_Default_Sales_Unit_of_Measure,
    setselect_Default_Sales_Unit_of_Measure,
  ] = useState("");
  const [Max_Discount, setMax_Discount] = useState("");
  const [Allow_Sales, setAllow_Sales] = useState("");
  const [Grant_Commission, setGrant_Commission] = useState("");
  const [Reading_required, setReading_required] = useState("");

  const [po_response, setpo_response] = useState("");
  // const [selected_item_data, setselected_item_data] = useState([]);

  const [status, setStatus] = useState("");
const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
  
  const [itemDetails, { data, isLoading }] = useGetItemDetailsDataMutation();
  
      useEffect(() => {
          if (IdData) {
              itemDetails({ doctype: 'Item', name: IdData })
                  .unwrap()
                  .then((response) => {
  const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;

  setpodata(response);
  console.log("Api response", item);

  setItemCode(item.item_code);
  setselect_group(item.item_group);
  setselect_category(item.custom_category);
  // setselect_company(item.company);
   setselect_company(item.item_defaults[0].company);
  setselect_brand(item.brand);
  setItemName(item.item_name);
  setselect_DefaultUnitOfMeasure(item.stock_uom);

  setselect_HSN_SAC(item.gst_hsn_code);
  setStandardSellingRate(item.standard_rate);
  setLength_MM(item.unicommerce_item_length);
  setWidth_MM(item.unicommerce_item_width);
  setHieght_MM(item.unicommerce_item_height);
  setDisabled(item.disabled);
  setMaintainStock(item.is_stock_item);
  setHasBatchNo(item.has_batch_no);
  setAutoCreateBatch(item.create_new_batch);
  setBatchPrefix(item.batch_number_series);
  setHasExpiryDate(item.has_expiry_date);
  setRetainSample(item.retain_sample);
  setsampleQuantity(item.sample_quantity);
  setHasSerialNo(item.has_serial_no);
  setSerialNumberSeries(item.serial_no_series);
  setSerialNoSetup(item.serial_no_setup);
  setHasVariants(item.has_variants);
  setDescription(item.description);
  setSpecification(item.specification);
  setselected_uom_item_data(item.uoms);
  setIs_Ineligible_for_Input_Tax_Credit(item.is_ineligible_for_itc);
  setselected_tax_item_data(item.taxes);
  setselect_Quality_Inspection_Template(item.quality_inspection_template);
  setInspection_Required_before_Purchase(item.inspection_required_before_purchase);
  setInspection_Required_before_Delivery(item.inspection_required_before_delivery);
  setInclude_Item_In_Manufacturing(item.include_item_in_manufacturing);
  setSupply_Raw_Materials_for_Purchase(item.delivered_by_supplier);

  setShelf_Life_In_Days(item.shelf_life_in_days);
  setEnd_of_Life(item.end_of_life);
  setDefaultMaterialRequestType(item.default_material_request_type);
  setValuationMethod(item.valuation_method);
  setWarrantyPeriod(item.warranty_period);
  setWeightPerUnit(item.weight_per_unit);
  setselect_WeightUOM(item.weight_uom);
  setAllowNegativeStock(item.allow_negative_stock);
  setselected_barcodes_item_data(item.barcodes);
  setselected_auto_re_order_item_data(item.reorder_levels);

  setselect_Default_Purchase_Unit_of_Measure(item.purchase_uom);
  setSafety_Stock(item.safety_stock);
  setMinimum_Order_Qty(item.min_order_qty);
  setLead_Time_in_days(item.lead_time_days);
  setAllow_Purchase(item.is_purchase_item);
  setIs_Customer_Provided_Item(item.is_customer_provided_item);
  setselect_Country_of_Origin(item.country_of_origin);
  setselect_CustomsTariffNumber(item.customs_tariff_number);
  setDelivered_by_Supplier(item.delivered_by_supplier);
  setselected_item_supplier_data(item.supplier_items);

  setselect_Default_Sales_Unit_of_Measure(item.sales_uom);
  setMax_Discount(item.max_discount);
  setAllow_Sales(item.is_sales_item);
  setGrant_Commission(item.grant_commission);
  setReading_required(item.reading_required);
  setselected_customer_details_data(item.customer_items);

  setStatus(item.disabled);
  setImage(item.image);
  setAttachmentsList(docinfo.attachments); // ✅ Correct place
})

                  .catch((err) => {
                      console.error('API Error:', err);
                  });
          } else {
              console.warn('No Id Data found in location state');
          }
      }, [IdData, itemDetails]);
  const handleSubmit = async () => {
    setFieldErrors({
      ItemCode: false,
      group: false,
      company: false,
      HSN_SAC: false,
      ItemName: false,
      DefaultUnitOfMeasures: false,
    });

    const newErrors = {
      ItemCode: !ItemCode,
      group: !select_group,
      category: !select_category,
      HSN_SAC: !select_HSN_SAC,
      ItemName: !ItemName,
      DefaultUnitOfMeasures: !select_DefaultUnitOfMeasure,
    };
    const FirsthasInvalidItem = "";
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);

    if (!ItemCode) {
      setptype("Error");
      setError("Please fill Item Code.");
      setShowError(true);
      return;
    }
    if (!select_group) {
      setptype("Error");
      setError("Please select Item Group.");
      setShowError(true);
      return;
    }

    if (!select_category) {
      setptype("Error");
      setError("Please select category.");
      setShowError(true);
      return;
    }
    if (!ItemName) {
      setptype("Error");
      setError("Please fill Item Name.");
      setShowError(true);
      return;
    }
    if (!select_DefaultUnitOfMeasure) {
      setptype("Error");
      setError("Please select Default UnitOf Measure.");
      setShowError(true);
      return;
    }
    if (!select_HSN_SAC) {
      setptype("Error");
      setError("Please select HSN/SAC.");
      setShowError(true);
      return;
    }
    let is_purchase_item = Allow_Purchase;
    let is_customer_provided_item = Is_Customer_Provided_Item;

    // Enforce mutual exclusivity
    if (is_purchase_item === true) {
      is_customer_provided_item = false;
    } else if (is_customer_provided_item === true) {
      is_purchase_item = false;
    }

    const payload = {
      name: IdData,
      // naming_series: "ITEM-",
      item_code: ItemCode,
      item_name: ItemName,
      item_group: select_group,
      gst_hsn_code: select_HSN_SAC,
      custom_item_group_2: "",
      custom_item_group_3: "",
      custom_category: select_category,
      brand: select_brand,
      stock_uom: select_DefaultUnitOfMeasure,
      standard_rate:StandardSellingRate,
      unicommerce_item_length: Length_MM,
      unicommerce_item_width: Width_MM,
      unicommerce_item_height: Hieght_MM,
      custom_is_public: "1",
      custom_is_discountable: "0",
      custom_best_seller: "1",
      custom_tag_price: "",
      custom_formula: "",
      disabled: Disabled,
      is_stock_item: MaintainStock,
      has_batch_no: HasBatchNo,
      create_new_batch: autoCreateBatch,
      batch_number_series: batchPrefix,
      has_expiry_date: hasExpiryDate,
      retain_sample: retainSample,
      sample_quantity: sampleQuantity,
      item_defaults:[{
      company:select_company,
      default_warehouse:paginatedData?.full_data?.[0]?.name
      }],
      has_serial_no: HasSerialNo,
      serial_no_series: SerialNumberSeries,
      serial_no_setup: SerialNoSetup,
      // has_variants: HasVariants,
      has_variants: false,
      valuation_rate: "",
      description: Description,
      specification: Specification,
      image: Image || "",
      uoms: selected_uom_item_data ? selected_uom_item_data : [],
      is_ineligible_for_itc: Is_Ineligible_for_Input_Tax_Credit,
      taxes: selected_tax_item_data ? selected_tax_item_data : [],
      quality_inspection_template: select_Quality_Inspection_Template,
      inspection_required_before_purchase: Inspection_Required_before_Purchase,
      inspection_required_before_delivery: Inspection_Required_before_Delivery,
      include_item_in_manufacturing: Include_Item_In_Manufacturing,
      delivered_by_supplier: Supply_Raw_Materials_for_Purchase,
      shelf_life_in_days: Shelf_Life_In_Days ||"",
      end_of_life: End_of_Life || "",
      default_material_request_type: DefaultMaterialRequestType || "",
      valuation_method: ValuationMethod || "",
      warranty_period: WarrantyPeriod || "",
      weight_per_unit: WeightPerUnit,
      weight_uom: select_WeightUOM,
      allow_negative_stock: AllowNegativeStock || "",

      barcodes: selected_barcodes_item_data ? selected_barcodes_item_data : [],
      reorder_levels: selected_auto_re_order_item_data ? selected_auto_re_order_item_data : [],

      purchase_uom: select_Default_Purchase_Unit_of_Measure,
      safety_stock: Safety_Stock,
      min_order_qty: Minimum_Order_Qty,
      lead_time_days: Lead_Time_in_days,

      is_purchase_item,
      is_customer_provided_item,

      supplier_items: selected_item_supplier_data ? selected_item_supplier_data : [],
      country_of_origin: select_Country_of_Origin,
      customs_tariff_number: select_CustomsTariffNumber,

      sales_uom: select_Default_Sales_Unit_of_Measure,
      max_discount: Max_Discount,
      is_sales_item: Allow_Sales,
      grant_commission: Grant_Commission,
      reading_required: Reading_required,
      customer_items: selected_customer_details_data ? selected_customer_details_data : [],
    };
    console.log("update item payload:", payload);
   try {
    const response = await UpdateItem(payload).unwrap();
  const data = response?.data;

  // 👇 Manually check for _server_messages in successful response
  let errorMessage = null;
  const serverMessages = data?._server_messages;

  if (serverMessages) {
    try {
      const parsedServer = JSON.parse(serverMessages);
      if (Array.isArray(parsedServer) && parsedServer.length > 0) {
        const parsedMessage = JSON.parse(parsedServer[0]);
        if (parsedMessage?.message) {
          errorMessage = parsedMessage.message;
        }
      }
    } catch (e) {
      console.warn("Error parsing _server_messages:", e);
    }
  }

  if (errorMessage) {
    // ❌ Error inside response — show as error
    setError(errorMessage);
    setptype("Error");
    setShowError(true);
    return; // 👈 prevent showing success message
  }

  // ✅ Success
  setpo_response(data);
  setError("Item updated successfully!");
  setptype("Success");
  setShowError(true);
  setTimeout(() => {
        navigate("/master/item/item-list"); 
      }, 2000);
} catch (err) {
  // ✅ Handle real network/API failure
  let errorMessage = "Updation failed";

  try {
    const data = err?.data;
    const serverMessages = data?._server_messages;
    if (serverMessages) {
      const parsedServer = JSON.parse(serverMessages);
      if (Array.isArray(parsedServer) && parsedServer.length > 0) {
        const parsedMessage = JSON.parse(parsedServer[0]);
        if (parsedMessage?.message) {
          errorMessage = parsedMessage.message;
        }
      }
    }

    if (!errorMessage && (data?.exception || data?.message)) {
      errorMessage = (data.exception || data.message).split(":").pop()?.trim();
    }
  } catch (e) {
    console.warn("Error parsing caught exception:", e);
  }

  setError(errorMessage);
  setptype("Error");
  setShowError(true);
}



};

  return (
    <FormLayout
      title="Edit Item"
      breadcrumbs={[
        { label: "Item" },
        { label: "Item List", url: "/master/item/item-list" },
      ]}
      status={'hide'}
      actionButtons={
         <>
          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
          >
            Save
          </Button>
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 2
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(2);
                  }}
                  href="javascript:void(0);"
                >
                  Inventory{" "}
                  {tab == 2 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 3
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(3);
                  }}
                  href="javascript:void(0);"
                >
                  Purchasing{" "}
                  {tab == 3 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 4
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(4);
                  }}
                  href="javascript:void(0);"
                >
                  Sales{" "}
                  {tab == 4 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            {/* <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            > */}
              {/* <span style={{ position: "relative", top: "-1px" }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span> */}
              {/* <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span> */}
             {/* <FileAttachmentManager
  doctype="Item"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}

            <Attachment doctype="Item"  docname={IdData}  /> 



            {/* </div> */}
          </div>
        </div>

        <div
          className="row d-flex justify-content-between"
          style={{ marginTop: "14px" }}
        >
          {tab == 1 && 
          <div
            className="col-12 "
            style={{
              visibility: tab == 1 ? "visible" : "hidden",
              height: tab == 1 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab1
                setselected_uom_item_data={setselected_uom_item_data}
                selected_uom_item_data={selected_uom_item_data}
                setselected_tax_item_data={setselected_tax_item_data}
                selected_tax_item_data={selected_tax_item_data}
                ItemCode={{
                  ItemCode: ItemCode,
                  setItemCode: setItemCode,
                  Error: fieldErrors.ItemCode,
                }}
                group={{
                  group_list: group_list,
                  setselect_group: setselect_group,
                  select_group: select_group,
                  Error: fieldErrors.group,
                }}
                category={{
                  category_list: category_list,
                  setselect_category: setselect_category,
                  select_category: select_category,
                  Error: fieldErrors.category,
                }}
                company={{
                  company_list: company_list,
                  setselect_company: setselect_company,
                  select_company: select_company,
                  Error: fieldErrors.company,
                }}
                brand={{
                  brand_list: brand_list,
                  setselect_brand: setselect_brand,
                  select_brand: select_brand,
                  Error: fieldErrors.brand,
                }}
                ItemName={{
                  setItemName: setItemName,
                  ItemName: ItemName,
                  Error: fieldErrors.ItemName,
                }}
                DefaultUnitOfMeasures={{
                  DefaultUnitOfMeasure_list: DefaultUnitOfMeasure_list,
                  setselect_DefaultUnitOfMeasure:
                    setselect_DefaultUnitOfMeasure,
                  select_DefaultUnitOfMeasure: select_DefaultUnitOfMeasure,
                  Error: fieldErrors.DefaultUnitOfMeasures,
                }}
                HSN_SAC={{
                  HSN_SAC_list: HSN_SAC_list,
                  setselect_HSN_SAC: setselect_HSN_SAC,
                  select_HSN_SAC: select_HSN_SAC,
                  Error: fieldErrors.HSN_SAC,
                }}
                StandardSellingRate={{
                  setStandardSellingRate: setStandardSellingRate,
                  StandardSellingRate: StandardSellingRate,
                  Error: fieldErrors.StandardSellingRate,
                }}
                Length_MM={{
                  setLength_MM: setLength_MM,
                  Length_MM: Length_MM,
                  Error: fieldErrors.Length_MM,
                }}
                Width_MM={{
                  setWidth_MM: setWidth_MM,
                  Width_MM: Width_MM,
                  Error: fieldErrors.Width_MM,
                }}
                Hieght_MM={{
                  setHieght_MM: setHieght_MM,
                  Hieght_MM: Hieght_MM,
                  Error: fieldErrors.Hieght_MM,
                  }}
                  image={{
                    image: Image,
                    onInputChange: onInputChangeTabOne,
                }}
                Disabled={{
                  Disabled: Disabled,
                  setDisabled: setDisabled,
                  Error: fieldErrors.Disabled,
                }}
                MaintainStock={{
                  MaintainStock: MaintainStock,
                  setMaintainStock: setMaintainStock,
                  Error: fieldErrors.MaintainStock,
                }}
                HasBatchNo={{
                  HasBatchNo: HasBatchNo,
                  setHasBatchNo: setHasBatchNo,
                  Error: fieldErrors.HasBatchNo,
                }}
                autoCreateBatch={{
                  autoCreateBatch: autoCreateBatch,
                  setAutoCreateBatch: setAutoCreateBatch,
                  Error: fieldErrors.autoCreateBatch,
                }}
                hasExpiryDate={{
                  hasExpiryDate: hasExpiryDate,
                  setHasExpiryDate: setHasExpiryDate,
                  Error: fieldErrors.hasExpiryDate,
                }}
                retainSample={{
                  retainSample: retainSample,
                  setRetainSample: setRetainSample,
                  Error: fieldErrors.retainSample,
                }}
                sampleQuantity={{
                  sampleQuantity: sampleQuantity,
                  setsampleQuantity: setsampleQuantity,
                  Error: fieldErrors.sampleQuantity,
                }}
                batchPrefix={{
                  batchPrefix: batchPrefix,
                  setBatchPrefix: setBatchPrefix,
                  Error: fieldErrors.batchPrefix,
                }}
                HasSerialNo={{
                  HasSerialNo: HasSerialNo,
                  setHasSerialNo: setHasSerialNo,
                  Error: fieldErrors.HasSerialNo,
                }}
                SerialNoSetup={{
                  SerialNoSetup: SerialNoSetup,
                  setSerialNoSetup: setSerialNoSetup,
                  Error: fieldErrors.SerialNoSetup,
                }}
                SerialNumberSeries={{
                  SerialNumberSeries: SerialNumberSeries,
                  setSerialNumberSeries: setSerialNumberSeries,
                  Error: fieldErrors.SerialNumberSeries,
                }}
                HasVariants={{
                  HasVariants: HasVariants,
                  setHasVariants: setHasVariants,
                  Error: fieldErrors.HasVariants,
                }}
                Description={{
                  Description: Description,
                  setDescription: setDescription,
                  Error: fieldErrors.Description,
                }}
                Specification={{
                  Specification: Specification,
                  setSpecification: setSpecification,
                  Error: fieldErrors.Specification,
                }}
                Is_Ineligible_for_Input_Tax_Credit={{
                  Is_Ineligible_for_Input_Tax_Credit:
                    Is_Ineligible_for_Input_Tax_Credit,
                  setIs_Ineligible_for_Input_Tax_Credit:
                    setIs_Ineligible_for_Input_Tax_Credit,
                  Error: fieldErrors.Is_Ineligible_for_Input_Tax_Credit,
                }}
                Quality_Inspection_Template={{
                  Quality_Inspection_Template_list:
                    Quality_Inspection_Template_list,
                  setselect_Quality_Inspection_Template:
                    setselect_Quality_Inspection_Template,
                  select_Quality_Inspection_Template:
                    select_Quality_Inspection_Template,
                  Error: fieldErrors.Quality_Inspection_Template,
                }}
                Inspection_Required_before_Purchase={{
                  Inspection_Required_before_Purchase:
                    Inspection_Required_before_Purchase,
                  setInspection_Required_before_Purchase:
                    setInspection_Required_before_Purchase,
                  Error: fieldErrors.Inspection_Required_before_Purchase,
                }}
                Inspection_Required_before_Delivery={{
                  Inspection_Required_before_Delivery:
                    Inspection_Required_before_Delivery,
                  setInspection_Required_before_Delivery:
                    setInspection_Required_before_Delivery,
                  Error: fieldErrors.Inspection_Required_before_Delivery,
                }}
                Include_Item_In_Manufacturing={{
                  Include_Item_In_Manufacturing: Include_Item_In_Manufacturing,
                  setInclude_Item_In_Manufacturing:
                    setInclude_Item_In_Manufacturing,
                  Error: fieldErrors.Include_Item_In_Manufacturing,
                }}
                Supply_Raw_Materials_for_Purchase={{
                  Supply_Raw_Materials_for_Purchase:
                    Supply_Raw_Materials_for_Purchase,
                  setSupply_Raw_Materials_for_Purchase:
                    setSupply_Raw_Materials_for_Purchase,
                  Error: fieldErrors.Supply_Raw_Materials_for_Purchase,
                }}
              />
            </div>
          </div>
}
{tab == 2 && 
          <div
            className="col-12"
            style={{
              visibility: tab == 2 ? "visible" : "hidden",
              height: tab == 2 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab2
                 ItemCode={{
                  ItemCode: ItemCode,
                  setItemCode: setItemCode,
                  
                  Error: fieldErrors.ItemCode,
                }}
                setselected_barcodes_item_data={setselected_barcodes_item_data}
                selected_barcodes_item_data={selected_barcodes_item_data}
                setselected_auto_re_order_item_data={
                  setselected_auto_re_order_item_data
                }
                selected_auto_re_order_item_data={selected_auto_re_order_item_data}
                Shelf_Life_In_Days={{
                  Shelf_Life_In_Days: Shelf_Life_In_Days,
                  setShelf_Life_In_Days: setShelf_Life_In_Days,
                  
                  Error: fieldErrors.Shelf_Life_In_Days,
                }}
                End_of_Life={{
                  setEnd_of_Life: setEnd_of_Life,
                  End_of_Life: End_of_Life,
                  Error: fieldErrors.End_of_Life,
                }}
                DefaultMaterialRequestType={{
                  DefaultMaterialRequestType: DefaultMaterialRequestType,
                  setDefaultMaterialRequestType: setDefaultMaterialRequestType,
                  Error: fieldErrors.DefaultMaterialRequestType,
                }}
                ValuationMethod={{
                  ValuationMethod: ValuationMethod,
                  setValuationMethod: setValuationMethod,
                  Error: fieldErrors.ValuationMethod,
                }}
                WarrantyPeriod={{
                  WarrantyPeriod: WarrantyPeriod,
                  setWarrantyPeriod: setWarrantyPeriod,
                  Error: fieldErrors.WarrantyPeriod,
                }}
                WeightPerUnit={{
                  WeightPerUnit: WeightPerUnit,
                  setWeightPerUnit: setWeightPerUnit,
                  Error: fieldErrors.WeightPerUnit,
                }}
                WeightUOM={{
                  WeightUOM_list: WeightUOM_list,
                  setselect_WeightUOM: setselect_WeightUOM,
                  select_WeightUOM: select_WeightUOM,
                  Error: fieldErrors.WeightUOM,
                }}
                AllowNegativeStock={{
                  setAllowNegativeStock: setAllowNegativeStock,
                  AllowNegativeStock: AllowNegativeStock,
                  Error: fieldErrors.AllowNegativeStock,
                }}
              />
            </div>
          </div>
}
{tab == 3 && 
          <div
            className="col-12"
            style={{
              visibility: tab == 3 ? "visible" : "hidden",
              height: tab == 3 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab3
                 ItemCode={{
                  ItemCode: ItemCode,
                  setItemCode: setItemCode,
                 
                  Error: fieldErrors.ItemCode,
                }}
                setselected_item_supplier_data={setselected_item_supplier_data}
                selected_item_supplier_data={selected_item_supplier_data}
                Default_Purchase_Unit_of_Measure={{
                  Default_Purchase_Unit_of_Measure_list:
                    Default_Purchase_Unit_of_Measure_list,
                  setselect_Default_Purchase_Unit_of_Measure:
                    setselect_Default_Purchase_Unit_of_Measure,
                  select_Default_Purchase_Unit_of_Measure:
                    select_Default_Purchase_Unit_of_Measure,
                  Error: fieldErrors.Default_Purchase_Unit_of_Measure,
                }}
                Safety_Stock={{
                  setSafety_Stock: setSafety_Stock,
                  Safety_Stock: Safety_Stock,
                  Error: fieldErrors.Safety_Stock,
                }}
                Minimum_Order_Qty={{
                  Minimum_Order_Qty: Minimum_Order_Qty,
                  setMinimum_Order_Qty: setMinimum_Order_Qty,
                  Error: fieldErrors.Minimum_Order_Qty,
                }}
                Lead_Time_in_days={{
                  Lead_Time_in_days: Lead_Time_in_days,
                  setLead_Time_in_days: setLead_Time_in_days,
                  Error: fieldErrors.Lead_Time_in_days,
                }}
                Allow_Purchase={{
                  Allow_Purchase: Allow_Purchase,
                  setAllow_Purchase: setAllow_Purchase,
                  Error: fieldErrors.Allow_Purchase,
                }}
                Is_Customer_Provided_Item={{
                  Is_Customer_Provided_Item: Is_Customer_Provided_Item,
                  setIs_Customer_Provided_Item: setIs_Customer_Provided_Item,
                  Error: fieldErrors.Is_Customer_Provided_Item,
                }}
                Country_of_Origin={{
                  Country_of_Origin_list: Country_of_Origin_list,
                  setselect_Country_of_Origin: setselect_Country_of_Origin,
                  select_Country_of_Origin: select_Country_of_Origin,
                  Error: fieldErrors.Country_of_Origin,
                }}
                CustomsTariffNumber={{
                  CustomsTariffNumber_list: CustomsTariffNumber_list,
                  setselect_CustomsTariffNumber: setselect_CustomsTariffNumber,
                  select_CustomsTariffNumber: select_CustomsTariffNumber,
                  Error: fieldErrors.CustomsTariffNumber,
                }}
                Delivered_by_Supplier={{
                  Delivered_by_Supplier: Delivered_by_Supplier,
                  setDelivered_by_Supplier: setDelivered_by_Supplier,
                  Error: fieldErrors.Delivered_by_Supplier,
                }}
              />
            </div>
          </div>
}
{tab == 4 && 
          <div
            className="col-12"
            style={{
              visibility: tab == 4 ? "visible" : "hidden",
              height: tab == 4 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab4
                 ItemCode={{
                  ItemCode: ItemCode,
                  setItemCode: setItemCode,
                  Error: fieldErrors.ItemCode,
                }}
                setselected_customer_details_data={
                  setselected_customer_details_data
                }
                selected_customer_details_data={selected_customer_details_data}
                Default_Sales_Unit_of_Measure={{
                  Default_Sales_Unit_of_Measure_list:
                    Default_Sales_Unit_of_Measure_list,
                  setselect_Default_Sales_Unit_of_Measure:
                    setselect_Default_Sales_Unit_of_Measure,
                  select_Default_Sales_Unit_of_Measure:
                    select_Default_Sales_Unit_of_Measure,
                  Error: fieldErrors.Default_Sales_Unit_of_Measure,
                }}
                Max_Discount={{
                  setMax_Discount: setMax_Discount,
                  Max_Discount: Max_Discount,
                  Error: fieldErrors.Max_Discount,
                }}
                Allow_Sales={{
                  Allow_Sales: Allow_Sales,
                  setAllow_Sales: setAllow_Sales,
                  Error: fieldErrors.Allow_Sales,
                }}
                Grant_Commission={{
                  Grant_Commission: Grant_Commission,
                  setGrant_Commission: setGrant_Commission,
                  Error: fieldErrors.Grant_Commission,
                }}
                Reading_required={{
                  Reading_required: Reading_required,
                  setReading_required: setReading_required,
                  Error: fieldErrors.Reading_required,
                }}
              />
            </div>
          </div>
}
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default EditForm;
